import React from "react";
import "./recommendations.css";

const Recommendations = ({ optionsProp, triggerNewTopicProp, backgroundUrlsProp, onContinue }) => {
    return (
        <div className="recommendations-container">
          {optionsProp.map((topic, index) => (
            <div
              key={index}
              className="recommendation-item"
              style={{ backgroundImage: `url(${backgroundUrlsProp[index]})`, backgroundSize: "cover", backgroundPosition: "center" }}
              onClick={() => triggerNewTopicProp(topic)}
            >
              <div className="overlay">{topic}</div>
            </div>
          ))}
          <button className="recommendation-continue-btn" onClick={onContinue}>
            Continue →
          </button>
        </div>
      );
};

export default Recommendations;